/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import {Claim, MyPolicy} from '../../auth/core/_models'
import {ClaimHubModel} from './ClaimHubModel'
import { useAuth } from '../../auth/core/Auth'

type Props = {
  className: string
  title: string
  description: string
  avatar: string
  policy: MyPolicy
  link: string | undefined
}

const ClaimHubLinkWidget: React.FC<Props> = ({className, title, description, avatar, policy, link}) => {
  const [modalShow, setModalShow] = useState(false)

  return (
    <>
      <a className={` `} onClick={() => setModalShow(true)}>
        <div
          className='border bg-light-primary border-primary border-dashed rounded 
                                                                 py-3 px-4 me-6 mb-3 border-hover-success 
                                                                bg-hover-primary text-hover-white'
        >
          <div className='d-flex align-items-center'>
            <div className='fs-6 fw-bolder'> {title} </div>
          </div>
        </div>
      </a>
      <ClaimHubModel show={modalShow} handleClose={() => setModalShow(false)} policy={policy} />
    </>
  )
}

export { ClaimHubLinkWidget }
